import React from 'react';
import { Link } from 'react-router-dom';

function Failed() {
  return (
    <div className="theme-copy-page result-page container mx-auto px-4 py-16">
      <div className="max-w-md mx-auto text-center">
        <div className="w-24 h-24 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <svg className="w-12 h-12 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </div>
        <h1 className="text-4xl font-bold text-gray-800 mb-4">Payment Failed</h1>
        <p className="text-gray-600 mb-8">
          Sorry, your payment could not be processed. Please try again or contact our support team for assistance.
        </p>
        <div className="space-y-3">
          <Link
            to="/cart"
            className="block w-full px-6 py-3 bg-primary text-white rounded-lg hover:bg-primary-dark transition font-medium"
          >
            Return to Cart
          </Link>
          <Link
            to="/contact"
            className="block w-full px-6 py-3 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition font-medium"
          >
            Contact Support
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Failed;
